var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{attrs:{"fields":_vm.fields,"table_store":"autoinformer/campaigns/tasks/table"},scopedSlots:_vm._u([{key:"state",fn:function(ref){
var item = ref.item;
return [_c('state-badge',{attrs:{"value":item.state}})]}},{key:"actions",fn:function(ref){
var item = ref.item;
return [(item.state === 'pending')?_c('table-control',{attrs:{"type":"trash"},on:{"click":function($event){return _vm.remove(item)}}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }